<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>地图配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="importUploadSuccess"
                :headers="headers"
              >
                <el-button v-permisaction="['config:mapConfig:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:mapConfig:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData"
              >导出</el-button>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:mapConfig:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportJsonData"
              >导出JSON</el-button>
            </el-col>
          </el-row>
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-row v-for="(item, index) in formData" :key="index">
            <el-form-item label="关卡ID">
              <el-input v-model.number="item.levelId" style="width: 100px;" placeholder="等级" />
            </el-form-item>
            <el-form-item label="多语言名称">
              <el-input v-model="item.langName" style="width: 150px;" placeholder="多语言名称" />
            </el-form-item>
            <el-form-item label="多语言名称KEY">
              <el-input v-model="item.langNameKey" style="width: 150px;" placeholder="多语言KEY" />
            </el-form-item>
            <el-form-item label="地图ICON">
              <el-input v-model="item.icon" style="width: 150px;" placeholder="地图ICON" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:mapConfig:del']" type="danger" @click="del(item.levelId, index)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item>
            <el-button v-permisaction="['config:mapConfig:add']" type="primary" @click="add()">+</el-button>
          </el-form-item>
          <el-button v-permisaction="['config:mapConfig:add']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>

    </template>
  </BasicLayout>
</template>

<script>
import { exportMapCfg, getMapCfg, importMapCfg, saveMapCfg } from '@/api/config/static-cfg'
import { getToken } from '@/utils/auth'
export default {
  name: 'MapConfig',
  data() {
    return {
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      formData: [
        {
          'levelId': 1,
          'langNameKey': '',
          'langName': '',
          'icon': ''
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      for (const i in this.formData) {
        const val = this.formData[i]
        if (val.langName === '') {
          this.msgError('关卡名不能为空')
          return
        }
        if (val.langNameKey === '') {
          this.msgError('多语言KEY不能为空')
          return
        }

        if (val.icon === '') {
          this.msgError('地图ICON不能为空')
          return
        }
      }
      const data = JSON.stringify(this.formData)
      saveMapCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getMapCfg().then(res => {
        if (res.code === 200) {
          this.formData = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      const id = this.formData.length
      this.formData.push({
        'levelId': id + 1,
        'langNameKey': '',
        'icon': ''
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importMapCfg({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportMapCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    del(id, index) {
      this.formData = this.formData.filter((item, key) => {
        return index !== key
      })
    },
    exportJsonData() {
      window.open(process.env.VUE_APP_BASE_API + '/api/v1/export/exportJsonMapCfg')
    }
  }
}
</script>

<style scoped>
</style>
